import { render, staticRenderFns } from "./manageParcelTl.vue?vue&type=template&id=81662364&scoped=true&"
import script from "./manageParcelTl.vue?vue&type=script&lang=js&"
export * from "./manageParcelTl.vue?vue&type=script&lang=js&"
import style0 from "./manageParcelTl.vue?vue&type=style&index=0&id=81662364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81662364",
  null
  
)

export default component.exports